<ng-container *ngIf="contacts">

    <div class="row no-gutters" *ngFor="let contact of contacts; let idx = index">
        <div class="col-sm-3" style="padding-right: 25px;">
            <mat-form-field class="full-width">
                <mat-label>{{ contact.trans.name | translate }}</mat-label>
                <input id="{{idPrefix}}entry_{{idx}}.input_text.{{contact.trans.name}}"
                       type="text" matInput
                       [(ngModel)]="contact.name"
                       (blur)="onChange()"
                       [disabled]="disabled">
            </mat-form-field>
        </div>

        <div class="col-sm-7">
            <mat-form-field class="full-width">
                <mat-label>{{ contact.trans.value | translate }}</mat-label>
                <input id="{{idPrefix}}entry_{{idx}}.input_text.{{contact.trans.value}}"
                       type="text" matInput
                       [(ngModel)]="contact.value"
                       (blur)="onChange()"
                       [disabled]="disabled">
            </mat-form-field>
        </div>

        <div class="col-sm-2" align="center">
            <button id="{{idPrefix}}entry_{{idx}}.btn.delete"
                    class="delete-btn"
                    mat-icon-button
                    color="primary"
                    matTooltip="{{ 'common.btn.delete' | translate }}"
                    (click)="removeContact(idx)">
                <mat-icon>clear</mat-icon>
            </button>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-sm-10 text-right">
            <a id="{{idPrefix}}btn.add"
               mat-stroked-button
               color="accent"
               class="add-btn"
               (click)="addContact()">
                {{ 'user_management.btn.add_contact' | translate }}
            </a>
        </div>

        <div class="col-sm-2" align="center">

        </div>
    </div>

</ng-container>
